import { Box, Grid, Stack, Typography, Chip, Button } from "@mui/material";
import { discount, robot } from "../../assets";
import styles from "../../style";

const Hero = () => {
  return (
    <Box
      component="section"
      id="home"
      className={styles.paddingY}
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Grid
        container
        spacing={4}
        alignItems="center"
        justifyContent="space-between"
      >
        {/* Left side – copy */}
        <Grid item xs={12} md={6}>
          <Stack spacing={3}>
            {/* Badge / Chip row */}
            <Stack direction="row" spacing={1} alignItems="center">
              <Box
                component="img"
                src={discount}
                alt="ATG Testing"
                sx={{ width: 32, height: 32 }}
              />
              <Chip
                label="Now with 7&quot; HD Touchscreen"
                color="primary"
                variant="filled"
                sx={{
                  fontWeight: 900,
                  bgcolor: "primary.main",
                  color: "primary.contrastText",
                  height: "auto",
                  py: 1,
                  px: 1.5,
                  "& .MuiChip-label": {
                    fontSize: (theme) => theme.typography.h5.fontSize,
                    lineHeight: (theme) => theme.typography.h5.lineHeight,
                    fontWeight: 900,
                  },
                }}
              />
            </Stack>

            <Typography
              variant="h5"
              sx={{ color: "rgba(255,255,255,0.75)" }}
            >
              ATG Monitor • Testing available in{" "}
              <Box component="span" sx={{ fontWeight: 600, color: "#fff" }}>
                Central Texas
              </Box>
            </Typography>

            {/* Main headline */}
            <Box>
              <Typography
                variant="h2"
                sx={{
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: 700,
                  fontSize: { xs: "2.6rem", md: "3.6rem" },
                  lineHeight: 1.1,
                  color: "#fff",
                }}
              >
                Smart, Simple <br />
                <Box component="span" className="text-gradient">
                  Tank Compliance.
                </Box>
              </Typography>
            </Box>

            {/* Sub-head about the new hardware/software */}
            <Typography
              variant="h4"
              sx={{
                fontWeight: 600,
                color: "rgba(255,255,255,0.9)",
                maxWidth: 520,
              }}
            >
              All-new 7&quot; HD touchscreen hardware and a completely rebuilt
              console designed specifically for busy station owners.
            </Typography>

            {/* Body copy */}
            <Typography
              variant="h5"
              sx={{
                color: "rgba(255,255,255,0.75)",
                maxWidth: 520,
              }}
            >
              Upgrade your legacy ATG to a modern, cloud-connected system.
              US Fuel Pro gives you real-time tank monitoring, automated
              compliance reports, and touchscreen control that feels like a
              modern app – not a 90&apos;s keypad.
            </Typography>

            {/* CTA row */}
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} mt={2}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                sx={{ fontWeight: 600, px: 4 }}
                href="#contact"
              >
                Book a Site Demo
              </Button>
              <Button
                variant="outlined"
                color="inherit"
                size="large"
                sx={{ borderColor: "rgba(255,255,255,0.4)" }}
                href="#features"
              >
                See What&apos;s New
              </Button>
            </Stack>

            {/* Small reassurance blurb */}
            <Typography
              variant="h6"
              sx={{ color: "rgba(255,255,255,0.6)" }}
            >
              Drop-in upgrade for existing Veeder-Root ATGs – keep your console,
              add a modern brain.
            </Typography>
          </Stack>
        </Grid>

        {/* Right side – hero visual */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                borderRadius: 4,
                overflow: "hidden",
                maxWidth: 520,
                width: "120%",
                backdropFilter: "blur(10px)",
              }}
            >
              <Box
                component="img"
                src={robot} // swap this for an actual console photo/screenshot when you have it
                alt="US Fuel Pro 7&quot; ATG Console"
                sx={{
                  width: "120%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>

            {/* gradients reusing your existing classes */}
            <Box className="pink__gradient" sx={{
              position: "absolute",
              zIndex: 0,
              width: "40%",
              height: "35%",
              top: 0,
            }} />
            <Box className="white__gradient" sx={{
              position: "absolute",
              zIndex: 1,
              width: "80%",
              height: "80%",
              borderRadius: "50%",
              bottom: 160,
            }} />
            <Box className="blue__gradient" sx={{
              position: "absolute",
              zIndex: 0,
              width: "50%",
              height: "50%",
              right: 80,
              bottom: 80,
            }} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Hero;
